import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ApplicationInsightsService, SeverityLevel } from '../services/application-insights.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  private readonly appInsightsService = inject(ApplicationInsightsService);

  override handleError(error: Error | HttpErrorResponse): void {
    super.handleError(error);

    // HTTP errors are handled by ApplicationInsightsInterceptor
    if (error instanceof HttpErrorResponse) {
      return;
    }

    this.appInsightsService.trackException(error, SeverityLevel.Error, {
      type: 'Runtime',
      message: error.message,
      stack: error.stack,
      name: error.name
    });
  }
}
